import { TextField } from '@nike/eds'
import { Search } from '@nike/nike-design-system-icons'
type GlobalSearchProps = {
  globalSearch: string
  handleGlobalSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export function GlobalSearch({ globalSearch, handleGlobalSearchChange }: GlobalSearchProps) {
  return (
    <div className='header-global-search'>
      <TextField
        id='global-search'
        className='header-global-search-input' // *NOTE: global classname if needed to override
        type='text'
        label=''
        placeholder='Search...'
        beforeSlot={<Search />}
        value={globalSearch || ''}
        onChange={handleGlobalSearchChange}
        hideLabel
    />
  </div>
  )
}
